module.exports = __webpack_public_path__ + "06906755e1c8dfeea4bc356adcfb99d3.png";